import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

const PENDING_KEY = 'luvall-pending-league-invite';

/**
 * Mount once globally. After sign-in, if a pending league invite code was stored
 * (e.g. user clicked a share link while logged out and signed up), redeem it
 * and route to the league.
 */
export function usePendingLeagueInvite() {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) return;
    let code: string | null = null;
    try { code = localStorage.getItem(PENDING_KEY); } catch {}
    if (!code) return;

    (async () => {
      try {
        const { data, error } = await supabase.rpc('redeem_league_invite' as any, { _code: code });
        if (error) throw error;
        const res = data as any;
        try { localStorage.removeItem(PENDING_KEY); } catch {}
        if (res?.error) {
          toast.error(`Could not auto-join league: ${res.error}`);
          return;
        }
        if (res?.league_id) {
          if (res.joined) toast.success('Joined league');
          navigate(`/leagues/${res.league_id}`);
        }
      } catch (err: any) {
        try { localStorage.removeItem(PENDING_KEY); } catch {}
        console.error('Pending league invite redemption failed:', err);
      }
    })();
  }, [user, navigate]);
}
